<template>
  <main>
    <Header />
    <div class="title" ref="title">
      <h1
        v-on:click="mailto"
        v-bind:style="translateXh1"
        ref="h1"
        v-html="titre"
      ></h1>
    </div>
    <div class="views" ref="view"></div>
    <div class="bgColor"></div>
  </main>
</template>
<script>
import Header from "@/components/header.vue";
export default {
  components: {
    Header
  },
  data() {
    return {
      titre: "pa.jobard<b>@</b>gmail.com",
      translateXtitle: {
        transform: "translateX(0px)"
      },
      translateXh1: {
        transform: "translateX(0px)"
      }
    };
  },
  methods: {
    handleMousemove(e) {
      var x = e.clientX;
      var w = this.$refs.view.offsetWidth;
      var titleW = this.$refs.h1.offsetWidth;
      var p = Math.round((x * 100) / w) / 100;
      var t = p * (titleW - w);

      this.$data.translateXh1.transform = "translateX(-" + t + "px)";
    },
    mailto() {
      window.location = "mailto:paul@jobard.design";
    }
  },
  created() {
    window.addEventListener("mousemove", this.handleMousemove);
  },
  destroyed() {
    window.removeEventListener("mousemove", this.handleMousemove);
  }
};
</script>
<style lang="scss">
#lezgo {
  transition: transform 0.1s ease 0s;
  &:hover {
    cursor: pointer;
    transform: scale(1.05) !important;
  }
}
</style>
